import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from './languages/translate.pipe';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CustomMessageService } from './custom-message.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ButtonModule, DropdownModule, FormsModule, CommonModule, ToastModule],
  providers: [TranslatePipe, MessageService, CustomMessageService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'premo_frontend';
  selectedLanguage?: Language;
  languages: Language[] = [
    { label: 'English', code: 'en' },
    { label: 'Spanish', code: 'es' },
    { label: 'French', code: 'fr' },
    { label: 'Chinese', code: 'zh' },
  ];

  constructor(
    private translatePipe: TranslatePipe,
    private location: Location,
    private router: Router
  ) {}

  async onLanguageChange(event: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const eventValue = (event as any).value as Language;
    this.translatePipe.getText.loadDictionary(eventValue.code);

    await this.router.navigate(['/loading'], { skipLocationChange: true });
    await this.router.navigate(['/premyopia-dashboard']);
  }
}

interface Language {
  label: string;
  code: string;
}
